import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.924 17.581c-2.105.698-6.387.442-10.061-1.73-.801-.474-1.7-1.106-2.537-.7-.557.27-1.114.928-1.303 2.43-.093.746.102 1.272.438 1.623 1.361 1.423 4.095-.221 4.198-2.188.096-1.861-.484-4.35-.446-5.894"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M21.354 8.262c-.106-.14-7.178-4.97-9.427-4.173-2.25.796-8.903 3.142-8.857 4.173.046 1.03 8.157 4.847 9.796 4.59 1.24-.212 5.403-3.232 5.908-1.991.525 1.264.483 5.971-1.85 6.72"
    />
  </svg>
);
export const EducationIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
